<div class="content-block content-block--card-details">
  <air-card-details
    [pointsEarned]="transactionOverview?.pointsEarned"
    [pointsSpent]="transactionOverview?.pointsSpent"
    [upcomingExpiration]="transactionOverview?.upcomingExpiration"
    [expirationsPageUrl]="content.expirationsPage?._url"
    [inboxPageUrl]="content.inboxPage?._url"
    [loading]="loading"
  >
  </air-card-details>
</div>
<div class="content-block content-block--recent-transactions">
  <air-recent-transactions
    [transactions]="transactionOverview?.recentTransactions"
    [transactionsPage]="content.transactionsPage"
    [showAll]="false"
    [loading]="loading"
  >
  </air-recent-transactions>
</div>
